import { useNavigate } from 'react-router';
import classes from './NvMeasureYourImpact.module.css';
import volunteer1 from '../../Assets/Images/volunteer1.svg';
import volunteer2 from '../../Assets/Images/volunteer2.svg';
import volunteer3 from '../../Assets/Images/volunteer3.svg';
import volunteer4 from '../../Assets/Images/volunteer4.svg';
import volunteer5 from '../../Assets/Images/volunteer5.svg';
import volunteer6 from '../../Assets/Images/volunteer6.svg';

// TODO: change images to cloudinary
// let volunteer1 = 'https://res.cloudinary.com/dof4l5eul/image/upload/v1743762347/AIESEC/volunteer1_y8tbrd.png';
// let volunteer2 = 'https://res.cloudinary.com/dof4l5eul/image/upload/v1743762345/AIESEC/volunteer2_zpfj6h.png';
// let volunteer3 = 'https://res.cloudinary.com/dof4l5eul/image/upload/v1743762348/AIESEC/volunteer3_rhc8bf.png';
// let volunteer4 = 'https://res.cloudinary.com/dof4l5eul/image/upload/v1743762346/AIESEC/volunteer4_dioynw.png';
// let volunteer5 = 'https://res.cloudinary.com/dof4l5eul/image/upload/v1743762348/AIESEC/volunteer5_wkssds.png';
// let volunteer6 = 'https://res.cloudinary.com/dof4l5eul/image/upload/v1743762346/AIESEC/volunteer6_mbaleu.png';

const NvMeasureYourImpact = () => {
  // Router
  const navigate = useNavigate();

  // Utils
  const why = [
    {
      text: 'Share a smile',
      image: volunteer1,
    },
    {
      text: 'Try new foods',
      image: volunteer2,
    },
    {
      text: 'Change a life',
      image: volunteer3,
    },
    {
      text: 'Build new friendships',
      image: volunteer4,
    },
    {
      text: 'Immerse yourself in new cultures',
      image: volunteer5,
    },
    {
      text: 'Make a difference',
      image: volunteer6,
    },
  ];
  return (
    <div className={classes.container}>
      <div className={classes.measureImpact}>
        <p>Measure your impact</p>
        <h4>
          Why should you <br /> volunteer?
        </h4>
      </div>
      <div className={classes.whySection}>
        {why.map((data, i) => {
          const words = data.text.split(' ');
          const isFifthItem = i === 4;

          return (
            <div
              key={i}
              style={{
                background: `url("${data.image}")`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
              }}
            >
              <span>
                {isFifthItem ? `${words[0]} ${words[1]}` : words[0]} <br />
                {isFifthItem
                  ? words.slice(2).join(' ')
                  : words.slice(1).join(' ')}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NvMeasureYourImpact;
